const createEnvironment = function (baseApi, authApi) {
  return {
    intervals: {
      logout: 3600, // 1 hour in seconds
    },
    api: {
      dashboard: `${baseApi}`,
      auth: `${authApi}`,
    },
    token: {
      auth: process.env.AUTH_TOKEN,
    },
    googleMaps: {
      apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    },
    googleOAuth: {
      clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    },
    turnstile: {
      siteKey: process.env.REACT_APP_TURNSTILE_SITEKEY || '',
    },
    subscription: {
      freeTrialDays: Number(process.env.REACT_APP_FREE_TRIAL_DAYS) || 30,
      freeTrialEarlyAdopterDays:
        Number(process.env.REACT_APP_FREE_TRIAL_EARLY_ADOPTER_DAYS) || 90,
    },
    analytics: {
      lastLoginTrackingSince:
        process.env.REACT_APP_LAST_LOGIN_TRACKING_SINCE || '2026-03-09',
    },
    marketplace: {
      url: 'https://test.market.edify.la',
    },
    isProduction: false,
    isDevelopment: true,
  };
};

export default createEnvironment;
